import React, { useState, useEffect } from 'react';
import { uid, addElementClass, removeElementClass } from '../_utils';
var defaults = {
    header: {
        warning: 'Warning',
        info: 'Info',
        danger: 'Error',
        success: 'Success'
    }
};
var Toast = function (props) {
    var _a = props.id, id = _a === void 0 ? uid() : _a, _b = props.visible, visible = _b === void 0 ? true : _b, _c = props.variant, variant = _c === void 0 ? 'info' : _c, message = props.message, messageInfo = props.messageInfo, description = props.description, _d = props.dismissable, dismissable = _d === void 0 ? true : _d, _e = props.animated, animated = _e === void 0 ? false : _e, onDismiss = props.onDismiss;
    var _f = useState(!!visible), isVisible = _f[0], setIsVisible = _f[1];
    useEffect(function () {
        if (animated)
            addElementClass(id, 'show');
    }, []);
    var destroy = function (e) {
        setIsVisible(false);
        if (onDismiss)
            onDismiss(e);
    };
    var hide = function (e) {
        if (animated) {
            removeElementClass(id, 'show');
            setTimeout(function () { return destroy(e); }, 500);
        }
        else
            destroy(e);
    };
    var messageText = message ? message : defaults.header[variant];
    return !!isVisible ? (React.createElement("div", { id: id, style: { minWidth: '20rem' }, className: "toast fade alert-" + variant + " " + (!animated && 'show'), role: "alert", "data-type": "toast", "aria-live": "assertive", "aria-atomic": "true", "data-autohide": "false" },
        React.createElement("div", { className: "toast-header" },
            React.createElement("strong", { className: "mr-auto" }, messageText),
            React.createElement("small", { className: "text-muted" }, messageInfo),
            !!dismissable && (React.createElement("button", { onClick: hide, type: "button", className: "ml-2 mb-1 close", "data-dismiss": "toast", "aria-label": "Close" },
                React.createElement("span", { "aria-hidden": "true" }, "\u00D7")))),
        !!description && (React.createElement("div", { className: "toast-body text-left" }, description)))) : null;
};
export default React.memo(Toast);
